import { ITaxWithheld } from "@modules/taxes/domain/entities/taxes.model";
import { Trade } from "./trade";

/*
	Model used in Swap Success screen as the response from swap Confirm call
*/

export class SwapConfirmTrade extends Trade {
	private taxWithheld: Partial<ITaxWithheld> = {};
	private fiatWalletTransactionId = "";
	private fiatWalletId = "";
	private tradeId = "";

	public getAmountTradable(): string {
		return this.getAmount() || super.getAmountTradable(); // Because index returns fiat amount, not cryptocoin_amount
	}

	public gettaxWithheld(): Partial<ITaxWithheld> {
		return this.taxWithheld;
	}

	public getFiatWalletTransactionId(): string {
		return this.fiatWalletTransactionId;
	}

	public getFiatWalletId(): string {
		return this.fiatWalletId;
	}

	public getTradeId(): string {
		return this.tradeId;
	}
}
